var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",attrs:{"id":"main"}},[_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.detail.details)}}),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"submit",on:{"click":_vm.next}},[_vm._v("点击进入")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9f6965e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/refined/alliance/index.vue
// module id = null
// module chunks = 